// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","sidebar":"App_sidebar__+GFRC","header":"App_header__fhC8n","main":"App_main__nhgh3","landing":"App_landing__IBeSP"};